import React, { useContext, useEffect, useState } from "react";
import Header from "./HeaderComponent";
import { AuthContext } from "./AuthContextComponent";
import { useManualUpload, useTheme } from "../hooks";
import useHeadComponent from "../hooks/HeaderHook";
import { CgNotifications } from "react-icons/cg";
import useInboxNotification from "../hooks/InboxNotificationHook";

const InboxNotification = () => {
  const { username, userInfo } = useContext(AuthContext);
  const { selectedPartner } = useManualUpload();
  const { Balance } = useHeadComponent(selectedPartner);
  const { theme } = useTheme();
  const {
    notifications,
    selected,
    selectedId,
    setSelectedId,
    currentQuestions,
    redirectModal,
    fetchCurrentUserQuestion,
  } = useInboxNotification();

  const { pwdUpdate, category } = userInfo || {};

  useEffect(() => {
    fetchCurrentUserQuestion();
  }, [username]);

  return (
    <div className="flex flex-col flex-1 w-full min-h-0">
      <Header Balance={Balance} theme={theme} />

      <div className="flex justify-center flex-1 w-full min-h-0 overflow-hidden font-sans text-gray-800">
        <div className="flex w-[1240px] min-h-0 p-6">
          {/* LEFT PANE */}
          <aside className="flex flex-col w-1/3 h-full overflow-y-auto bg-white border-r border-gray-300 rounded-l-lg">
            <div className="sticky top-0 z-10 flex items-center gap-2 p-4 text-lg font-semibold bg-white border-b border-gray-300">
              <CgNotifications size={30} /> Inbox
            </div>

            <div className="flex-1 pb-4 overflow-y-auto inbox-custom-scrollbar">
              <ul>
                {notifications.map((notif) => (
                  <li
                    key={notif.id}
                    onClick={() => setSelectedId(notif.id)}
                    className={`px-4 py-3 border-b cursor-pointer hover:bg-gray-100 ${
                      selectedId === notif.id
                        ? "bg-gray-100 font-semibold border-l-4 border-l-red-500 ease-linear duration-100 transition-all"
                        : ""
                    }`}
                  >
                    <div className="flex items-center gap-4 text-sm">
                      <div className="flex items-center justify-center w-8 text-sm font-bold text-white bg-red-500 rounded-full aspect-square sm:w-9 sm:text-base md:w-12 md:text-lg lg:w-14 lg:text-xl">
                        {notif.sender.charAt(0)}
                      </div>
                      <div className="flex justify-between w-full text-sm">
                        <span className="text-xs md:text-sm lg:text-md">
                          {notif.title}
                        </span>
                        <span className="text-[10px] text-gray-500">
                          {notif.time}
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </aside>

          {/* RIGHT PANE */}
          <main className="flex-1 p-6 overflow-auto bg-gray-100 rounded-r-lg">
            <div className="max-w-3xl p-6 mx-auto">
              <div className="mb-4">
                <h2 className="text-lg font-semibold">{selected.title}</h2>
                <p className="text-xs text-gray-500">{selected.time}</p>
              </div>

              <div className="p-6 mb-6 bg-white rounded-md shadow">
                <p className="mb-4">
                  Hey {selected.sender},
                  <br />
                  <br />
                  {selected.message}
                </p>
                <p className="text-sm text-gray-600">
                  Best regards, <br /> John Smith
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default InboxNotification;
